import { ActionTypes as action } from "./action-types";
import widgetService from "../../../api/widgetService";
import tenantConfigService from "../../../api/tenantConfigService";

const actions = {
  async getPanelWidgets({ state, commit }) {
    const widgets = [];
    const results = await widgetService.getWidgetList();
    results.forEach((data) => {
      const isShow = { isShow: true };
      const widget = { ...isShow, ...data };
      widgets.push(widget);
    });
    commit(action.GET_PANEL_LIST, results);
    return widgets;
  },
  addPanel({ commit }, data) {
    commit(action.ADD_PANEL, data);
  },
  updatePanel({ commit }, data) {
    commit(action.UPDATE_PANEL, data);
  },
  removePanel({ commit }, id) {
    commit(action.REMOVE_PANEL, id);
  },
  widgetToggle({ commit }, value) {
    commit(action.PANEL_TOGGLE, value);
  },
  disableOnload({ commit }) {
    commit(action.PANEL_DISABLE);
  },
  widgetEnable({ commit }) {
    commit(action.PANEL_DISABLE);
  },
  setLastRowIndex({ commit }, index) {
    commit("setLastRow", index);
  },
  removeHoldWidgetList({ commit }) {
    commit("resetDisableWidgets");
  },
  async getDefaultConfig({ commit }) {
    const data = await tenantConfigService.getTenantConfigList();
    commit(action.GET_DEFAULT_SETTINGS, data);
    return;
  },
  async createTenantConfig({ dispatch }, data) {
    try {
      await tenantConfigService.createTenantConfig(data);
      await dispatch("getDefaultConfig");
      return;
    } catch (error) {
      console.log(error);
    }
  },
  resetState({ commit }) {
    commit(action.RESET_STATE);
  },
};

export default actions;
